import { ReactNode } from 'react'

interface KeywordMatchBulletsProps {
  aol: string
  bullets: Array<{
    title: ReactNode
    url: string
    keyword: string
    basicTitle: string
  }>
  collapsed: boolean
  maxHeight?: number
}

const KeywordMatchBullets = ({ aol, bullets, collapsed, maxHeight }: KeywordMatchBulletsProps): JSX.Element => {
  const visibleBullets = collapsed ? bullets.slice(0, 2) : bullets
  const style = collapsed && maxHeight !== undefined
    ? { maxHeight }
    : { maxHeight: 200 }
  const containerClass = collapsed && maxHeight !== undefined
    ? 'pt2 overflow-hidden db relative'
    : 'pt2 overflow-y-auto db relative'

  return (
    <div
      className={containerClass}
      style={style}
    >
      {visibleBullets.map((b, i) => (
        <div key={i} className='db w-100'>
          <span className='b'>• </span>
          <a
            href={b.url}
            className='link no-underline hover-underline black'
            tabIndex={0}
            data-event-category='Keyword'
            data-event-action='Result'
            data-event-label={`Keyword: [${b.keyword}] | Title: [${b.basicTitle}] | URL: [${b.url}]`}
            data-event-aol={aol}
          >
            {b.title}
          </a>
        </div>
      ))}
    </div>
  )
}

export default KeywordMatchBullets
